<template>
  <Modal
    className="project-leave-modal"
    :visible="visibleModal"
    :title="generateTitle"
    @onCancel="handleCancel"
    @onOk="handleOk"
    :width="700"
    :loading="loading"
    :type="type"
  >
    <template v-if="type === REMOVE_TYPE"> Do you want to delete this project leave?</template>
    <template v-else>
      <!-- <a-form :form="formRQ" v-bind="formItemLayout" formLayout="horizontal" class="tms-form"> -->
        <a-form :form="formRQ" v-bind="formItemLayout" class="tms-form">
        <a-form-item label="Staff" v-if="fromPage === PROJECT_LEAVE_DETAIL_SCREEN">
          <a-input
            disabled
            placeholder="Staff"
            v-decorator="[
              'staffInfo',
              {
                initialValue: formData.staffInfo,
                rules: [
                  {
                    required: true,
                    message: 'Staff is required',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Project">
          <a-select
            v-if="type === CREATE_TYPE && fromPage === PROJECT_LEAVE_SCREEN"
            allowClear
            showSearch
            :filterOption="false"
            placeholder="Search Project"
            :defaultActiveFirstOption="false"
            @change="handleChangeProject"
            @search="(value) => onSearch(value)"
            @popupScroll="popupScroll"
            v-decorator="[
              'projectId',
              {
                initialValue: formData.projectId,
                rules: [
                  {
                    required: true,
                    message: 'Project is required',
                  },
                ],
              },
            ]"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="project in projectFilterList" :key="project.project_id" :value="project.project_id">
              {{ project.project_name }}
            </a-select-option>
          </a-select>
          <a-select
            v-else-if="type === CREATE_TYPE && fromPage === PROJECT_LEAVE_DETAIL_SCREEN"
            showSearch
            :filterOption="filterOption"
            placeholder="Search Project"
            v-decorator="[
              'projectId',
              {
                initialValue: formData.projectId,
                rules: [
                  {
                    required: true,
                    message: 'Project is required',
                  },
                ],
              },
            ]"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="project in projectFilterList" :key="project.project_id" :value="project.project_id">
              {{ project.project_name }}
            </a-select-option>
          </a-select>
          <a-input
            v-if="fromPage === PROJECT_LEAVE_DETAIL_SCREEN && type === EDIT_TYPE"
            disabled
            v-decorator="[
              'projectName',
              {
                initialValue: formData.projectName,
                rules: [
                  {
                    required: true,
                    message: 'Project is required',
                  },
                ],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Staff" v-if="fromPage === PROJECT_LEAVE_SCREEN">
          <a-select
            :disabled="!formRQ.getFieldValue('projectId')"
            showSearch
            mode="multiple"
            :filterOption="filterOptionKeyMatch"
            placeholder="Search Staff"
            v-decorator="[
              'usernames',
              {
                initialValue: formData.usernames,
                rules: [
                  {
                    required: true,
                    message: 'Staff is required',
                  },
                ],
              },
            ]"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="{ value, label } in employeeByProjectList" :key="value" :value="value">
              {{ label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Leave Day (s)">
          <a-input
            class="leave-day"
            placeholder="Enter leave day (s)"
            style="width: 100%"
            v-decorator="[
              'leaveDay',
              {
                initialValue: formData.leaveDay,
                rules: [
                  {
                    required: true,
                    message: 'Leave Day is required',
                  },
                  {
                    validator: validateNumber,
                  },
                ],
              },
            ]"
          >
            <template slot="suffix">day(s)</template>
          </a-input>
        </a-form-item>
        <a-form-item label="Apply Date">
          <a-date-picker
            allowClear
            style="width: 100%"
            :format="DATE_FORMAT_V2"
            :disabledDate="handleDisabledDateApply"
            v-decorator="[
              'applyDate',
              {
                initialValue: formData.applyDate,
                rules: [
                  {
                    required: true,
                    message: 'Apply Date is required',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Expire Date">
          <a-date-picker
            allowClear
            style="width: 100%"
            :format="DATE_FORMAT_V2"
            :disabledDate="handleDisabledExpireDate"
            v-decorator="[
              'expireDate',
              {
                initialValue: formData.expireDate,
                rules: [
                  {
                    required: true,
                    message: 'Expired Date is required',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="File">
          <a-upload
            :multiple="true"
            name="file"
            :fileList="fileList"
            :beforeUpload="beforeUpload"
            :remove="removeFile"
            :customRequest="() => {}"
          >
            <Button icon="attachment" type="primary">Attach Files</Button>
          </a-upload>
        </a-form-item>
      </a-form>
    </template>
  </Modal>
</template>

<script>
import { Button, Modal } from "@/components";
import {
  countDecimals,
  CREATE_TYPE,
  DATE_FORMAT_V2,
  DATE_FORMAT_V2_FULL,
  EDIT_TYPE,
  filterOption,
  filterOptionKeyMatch,
  formatStringToDate,
  getInfoStaff,
  handleMessagesAPI,
  isNumeric,
  PROJECT_LEAVE_DETAIL_SCREEN,
  PROJECT_LEAVE_SCREEN,
  REMOVE_TYPE,
  validateFile,
} from "@/utils";
import { mapState } from "vuex";
import moment from "moment";
import { v4 as uuid } from "uuid";
import {
  GET_EMPLOYEE_BY_PROJECT_LIST,
  GET_PROJECT_REDIS_LIST_BY_PAGINATION,
  SET_PAGE_SELECT,
} from "@/store/mutation-types";

export default {
  name: "ProjectLeaveModal",
  components: {
    Modal,
    Button,
  },
  props: {
    visibleModal: {
      type: Boolean,
      require: true,
    },
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
    type: {
      type: String,
    },
    fromPage: {
      type: String,
      required: true,
      validator(value) {
        return [PROJECT_LEAVE_SCREEN, PROJECT_LEAVE_DETAIL_SCREEN].includes(value);
      },
    },
    projectLeaveByEmployeeInfo: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      formRQ: this.$form.createForm(this, { name: "formProjectLeave" }),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20, offset: 0 },
        layout: "horizontal" 
        // labelCol: { span: 5 },
        // wrapperCol: { span: 19 },
      }, 
      formData: {},
      DATE_FORMAT_V2,
      timeout: null,
      fetching: false,
      loading: false,
      PROJECT_LEAVE_SCREEN,
      PROJECT_LEAVE_DETAIL_SCREEN,
      projectFilterList: [],
      FolderName: "ProjectLeave",
      fileList: [],
      CREATE_TYPE,
      REMOVE_TYPE,
      EDIT_TYPE,
      disabledScroll: false,
    };
  },
  computed: {
    ...mapState({
      projectList: (state) => state.filters.projectList,
      projectRedisList: (state) => state.filters.projectRedisList,
      projectRedisListByPagination: (state) => state.filters.projectRedisListByPagination,
      projectByEmployeeList: (state) => state.filters.projectByEmployeeList,
      employeeList: (state) => state.filters.employeeList,
      employeeByProjectList: (state) => state.filters.employeeByProjectList,
      timeServer: (state) => state.application.timeServer,
      mostRecentTimeSheetApproved: (state) => state.advance.mostRecentTimeSheetApproved,
    }),
    generateTitle() {
      switch (this.type) {
        case CREATE_TYPE:
          return "Add Project Leave";
        case EDIT_TYPE:
          return "Edit Project Leave";
        case REMOVE_TYPE:
          return "Please Confirm";
        default:
          return "Add Project Leave";
      }
    },
  },
  async created() {
    // Get Time Server
    try {
      this.$store.dispatch("application/getTimeServer");
      this.$store.dispatch("advance/getMostRecentTimeSheetApproved");
    } catch (error) {
      handleMessagesAPI(error.response.data);
    }
    const { fromPage, projectLeaveByEmployeeInfo, type, data } = this;
    if (fromPage === PROJECT_LEAVE_DETAIL_SCREEN) {
      if (type === CREATE_TYPE) {
        this.formData = { ...this.formData, staffInfo: projectLeaveByEmployeeInfo?.fullName };
        await this.$store.dispatch("filters/getProjectByEmployeeList", {
          username: projectLeaveByEmployeeInfo.userName,
          projectName: " ",
        });
        this.projectFilterList = this.projectByEmployeeList;
      } else {
        const { applyDateFormat, expireDateFormat, leaveDay, projectName, attachFilePaths } = data;
        this.formData = {
          ...this.formData,
          staffInfo: projectLeaveByEmployeeInfo?.fullName ?? "",
          leaveDay,
          projectName,
          applyDate: formatStringToDate(applyDateFormat),
          expireDate: formatStringToDate(expireDateFormat),
        };
        attachFilePaths?.length &&
          (this.fileList = attachFilePaths.map(({ fileName, filePath }) => ({
            uid: uuid(),
            name: fileName,
            fileName,
            filePath,
            status: "done",
            old: true,
          })));
      }
    } else {
      await this.$store.dispatch("filters/getProjectRedisList", "");
      this.projectFilterList = this.projectRedisListByPagination;
    }
  },
  methods: {
    getInfoStaff,
    filterOption,
    filterOptionKeyMatch,
    handleChangeProject(projectId) {
      this.formRQ.setFieldsValue({ usernames: [] });
      if (projectId) {
        this.formRQ.setFieldsValue({ projectId });
        this.$store.dispatch("filters/getEmployeeByProjectList", {
          projectId,
        });
      } else {
        this.$store.commit(`filters/${SET_PAGE_SELECT}`, 1);
        this.$store.commit(`filters/${GET_EMPLOYEE_BY_PROJECT_LIST}`, []);
        this.$store.commit(`filters/${GET_PROJECT_REDIS_LIST_BY_PAGINATION}`);
        this.projectFilterList = this.projectRedisListByPagination;
      }
    },
    handleDisabledDateApply(date) {
      const { mostRecentTimeSheetApproved } = this;
      const expireDate = this.formRQ.getFieldValue("expireDate");
      return (
        (expireDate &&
          moment(date)
            .startOf("day")
            .isAfter(moment(expireDate).startOf("day"))) ||
        moment(date)
          .startOf("day")
          .isSameOrBefore(moment(mostRecentTimeSheetApproved, DATE_FORMAT_V2_FULL).startOf("day"))
      );
    },
    handleDisabledExpireDate(date) {
      const applyDate = this.formRQ.getFieldValue("applyDate");
      return (
        (applyDate &&
          moment(date)
            .startOf("day")
            .isBefore(moment(applyDate).startOf("day"))) ||
        moment(date)
          .startOf("day")
          .isBefore(moment(this.timeServer, DATE_FORMAT_V2_FULL).startOf("day"))
      );
    },
    beforeUpload(file) {
      const acceptType = [".pdf", ".txt", ".csv", ".mp4", ".jpg", ".jpeg", ".docx", ".xlsx", ".png", ".pptx"];
      const { isValid, message } = validateFile(file, acceptType);
      if (!isValid) {
        this.$toast.error(message);
      } else {
        this.fileList.push(file);
      }
      return !isValid;
    },
    removeFile(fileRemove) {
      this.fileList = this.fileList.filter((file) => file.uid !== fileRemove.uid);
    },

    validateNumber(rule, value, callback) {
      if (value) {
        if (!isNumeric(value)) {
          callback("Leave day(s) is invalid");
        } else if (Number(value) <= 0 || Number(value) > 31) {
          callback("Leave day(s) must be between 0 and 31");
        } else if (countDecimals(Number(value)) > 3) {
          callback("Leave day(s) is invalid (example: 1.135, ...)");
        }
      }
      callback();
    },
    popupScroll(e) {
      if (!this.disabledScroll) {
        const { scrollTop, scrollHeight, offsetHeight } = e.target;
        if (scrollTop + offsetHeight === scrollHeight) {
          this.$store.commit(`filters/${GET_PROJECT_REDIS_LIST_BY_PAGINATION}`);
          this.projectFilterList = this.projectRedisListByPagination;
        }
      }
    },
    handleCancel() {
      this.formRQ.resetFields();
      this.$emit("onCancel");
    },
    onSearch(value, timeout = 1000) {
      if (!value || !value.trim() || value.trim().length <= 2) {
        if (!value) {
          this.$store.commit(`filters/${SET_PAGE_SELECT}`, 1);
          this.$store.commit(`filters/${GET_EMPLOYEE_BY_PROJECT_LIST}`, []);
          this.$store.commit(`filters/${GET_PROJECT_REDIS_LIST_BY_PAGINATION}`);
          this.projectFilterList = this.projectRedisListByPagination;
          this.disabledScroll = false;
        }
        return;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.fetching = true;
      this.timeout = setTimeout(async () => {
        try {
          const projectFilter = this.projectRedisList.filter(
            (project) => project.project_name.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );
          this.projectFilterList = projectFilter;
        } finally {
          this.disabledScroll = true;
          this.fetching = false;
        }
      }, timeout);
    },
    handleOk() {
      this.formRQ.validateFields(async (error, values) => {
        if (error) return;
        values.applyDate && (values.applyDate = moment(values.applyDate).format(DATE_FORMAT_V2));
        values.expireDate && (values.expireDate = moment(values.expireDate).format(DATE_FORMAT_V2));
        const { type, fromPage, data, fileList, projectLeaveByEmployeeInfo } = this;
        let { ...payload } = values;
        let isUseFormData = true;
        let action = "";
        const formData = new FormData();
        //#region check type
        if (type === CREATE_TYPE && fromPage === PROJECT_LEAVE_SCREEN) {
          action = "addProjectLeaveV2";
        } else if (type === CREATE_TYPE && fromPage === PROJECT_LEAVE_DETAIL_SCREEN) {
          action = "addProjectLeaveV2";
          payload = { ...payload, usernames: [projectLeaveByEmployeeInfo?.userName] };
        } else if (type === EDIT_TYPE) {
          action = "editProjectLeaveByEmployeeV2";
          payload = { ...payload, id: data.id, attachFilePaths: fileList?.filter((file) => file.old) };
        } else if (type === REMOVE_TYPE) {
          action = "deleteProjectLeaveByEmployee";
          payload = { id: data.id };
          isUseFormData = false;
        }
        //#endregion

        if (fileList?.length > 0) {
          fileList.forEach((file) => {
            if (!file.old) {
              formData.append("files", file);
            }
          });
        }
        formData.append(
          "projectLeaveRequest",
          new Blob([JSON.stringify(payload)], {
            type: "application/json",
          })
        );
        this.loading = true;
        try {
          const res = await this.$store.dispatch(`projectLeave/${action}`, isUseFormData ? formData : payload);
          const { code, response } = res;
          if (code == 400) {
            handleMessagesAPI(res);
          } else {
            response?.forEach((item) => {
              handleMessagesAPI(item);
            });
          }
          if (code == 200) {
            this.$emit("getData");
            this.handleCancel();
          }
        } catch (error) {
          handleMessagesAPI(error.response.data);
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.project-leave-modal {
  .ant-form-item {
    margin-bottom: 16px;

    ::v-deep .leave-day {
      input {
        padding-right: 48px;
      }
    }
  }
}
</style>
